import APP_ROUTES from "src/routes/routes";
import { usePatchedNavigate } from "../usePatchedNavigate";
import { useQuery } from "../useReactQuery";
import { getTagsByResources } from "src/services/tags-service";

const useGetTagsByResources = (
  {
    page = 1,
    limit = 9999999,
    q,
    resourceIds,
    resourceType,
    isSelectOptions,
    key = "getTagsByResources",
    enabled = true,
    refetchOnWindowFocus = true,
  } = {},
  onSettledCallback
) => {
  const navigate = usePatchedNavigate();

  const queryFn = () => {
    const item_ids = Array.isArray(resourceIds) ? resourceIds.join(",") : resourceIds;

    const params = {
      page,
      limit,
      ...(q && { q }),
      item_ids,
      resource_type: resourceType,
    };
    return getTagsByResources(params);
  };

  const { data, isError, error, refetch, isFetching, isLoading } = useQuery({
    queryKey: [key, q, resourceIds, resourceType, page],
    queryFn,
    cacheTime: 0,
    select: (data) => {
      let finalData = data;
      if (isSelectOptions) {
        return (
          finalData?.items?.map((item) => ({
            label: item.name,
            value: item.id,
          })) || []
        );
      }
      return finalData;
    },
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
    onSettled: () => {
      if (onSettledCallback) {
        onSettledCallback();
      }
    },
    enabled,
    refetchOnWindowFocus,
  });

  return {
    data,
    refetch,
    isFetching,
    isLoading,
    isError,
    error,
  };
};

export default useGetTagsByResources;
